export const B2B_CHAT_UNREAD_REFRESH_EVENT = "b2b-chat-unread-refresh";

export function dispatchChatUnreadRefresh(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(B2B_CHAT_UNREAD_REFRESH_EVENT));
}
